import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useEffect, Suspense, lazy } from "react";
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from "./components/ui/toaster";
import { Toaster as SonnerToaster } from 'sonner';
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import InterlinkBanner from "./components/InterlinkBanner";

import HomePage from "./pages/HomePage";
const RentalPage = lazy(() => import("./pages/RentalPage"));
const EquipmentPage = lazy(() => import("./pages/EquipmentPage"));
const ContactPage = lazy(() => import("./pages/ContactPage"));
const AdminPage = lazy(() => import("./pages/AdminPage"));
const GuideTahaaPage = lazy(() => import("./pages/GuideTahaaPage"));
const PaymentSuccess = lazy(() => import("./pages/PaymentSuccess"));
const PaymentCancel = lazy(() => import("./pages/PaymentCancel"));

// Composant pour les redirections externes vers le site de bateau
const ExternalRedirect = ({ url }) => {
  useEffect(() => {
    window.location.href = url;
  }, [url]);
  return null;
};

// Composant de chargement simple
const PageLoader = () => (
  <div className="min-h-[60vh] flex items-center justify-center">
    <div className="w-8 h-8 border-4 border-cyan-600 border-t-transparent rounded-full animate-spin"></div>
  </div>
);

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <div className="font-sans text-[#1A1A1A] antialiased selection:bg-[#00A3B1] selection:text-white bg-[#F9F7F2] min-h-screen flex flex-col">
          <Navbar />
          <div className="flex-grow">
            <Suspense fallback={<PageLoader />}>
              <Routes>
                {/* 1. PAGES LOCALES */}
                <Route path="/" element={<HomePage />} />
                <Route path="/location-de-kayak/" element={<RentalPage />} />
                <Route path="/materiels-equipements/" element={<EquipmentPage />} />
                <Route path="/formulaire-de-contact/" element={<ContactPage />} />
                <Route path="/admin/" element={<AdminPage />} />
                <Route path="/guide-tahaa/" element={<GuideTahaaPage />} />
                <Route path="/payment-success/" element={<PaymentSuccess />} />
                <Route path="/payment-cancel/" element={<PaymentCancel />} />

                {/* 2. REDIRECTIONS VERS LE SITE BATEAU */}
                <Route 
                  path="/elementor-3789/" 
                  element={<ExternalRedirect url="https://tahaa-excursions.com" />} 
                />
                <Route 
                  path="/product-category/excursion/" 
                  element={<ExternalRedirect url="https://tahaa-excursions.com" />} 
                />

                {/* 3. FILET DE SÉCURITÉ */}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Suspense>
          </div>
          
          <InterlinkBanner />
          <Footer />
          <WhatsAppButton />
          <Toaster />
          <SonnerToaster position="bottom-right" richColors />
        </div>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;